import { defineComponent as r, createBlock as t, openBlock as n, unref as v, mergeProps as m, withCtx as p, createElementVNode as l } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconCompare",
  __name: "IconCompare",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (n(), t(v(c), m(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h9a2.25 2.25 0 0 1 2.25 2.25v3.75h3.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-3.75H4.5a2.25 2.25 0 0 1-2.25-2.25v-9m7.5 11.25v3.75a.75.75 0 0 0 .75.75h9a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75h-3.75v3.75a2.25 2.25 0 0 1-2.25 2.25H9.75m4.5-6v3.75a.75.75 0 0 1-.75.75H9.75V10.5a.75.75 0 0 1 .75-.75h3.75m0-1.5H10.5a2.25 2.25 0 0 0-2.25 2.25v3.75H4.5a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 4.5 3.75h9a.75.75 0 0 1 .75.75v3.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
